import errorTracker from './errorTracker';

const isProduction = process.env.NODE_ENV === 'production';

const logger = {
	log: (...args) => {
		if (!isProduction) {
			// eslint-disable-next-line no-console
			console.log(...args);
		}
	},
	warn: (...args) => {
		if (!isProduction) {
			// eslint-disable-next-line no-console
			console.warn(...args);
		}
	},
	error: (...args) => {
		if (!isProduction) {
			// eslint-disable-next-line no-console
			console.error(...args);
		}
		try {
			const first = args[0] instanceof Error ? args[0] : new Error(String(args[0]));
			errorTracker.trackError(first, { source: 'logger.error' });
		} catch {}
	}
};

export default logger;




